function fetchCdnUrl() {
  const cdnUrl = import.meta.env.VITE_CDN_URL
  const invalidUrls = [null, undefined, 'undefined', 'null', '']
  return !invalidUrls.includes(cdnUrl) ? cdnUrl : null
}

export function buildPublicResourceUrl(path) {
  const cdnUrl = fetchCdnUrl()
  return cdnUrl ? `${cdnUrl}/public${path}` : `${path}`
}

export enum ImageSize {
  square100 = '100x100'
}

export function buildImageResourceUrlByKey(key, size: ImageSize = ImageSize.square100) {
  const cdnUrl = fetchCdnUrl()
  return cdnUrl ? `${cdnUrl}/images/${key}_${size}.jpg` : null
}
